// src/components/Careers/Careers.js
import React from 'react';
import LifeAndPeople from './LifeAndPeople/LifeAndPeople';
import Mission from './Mission/Mission';
import Benefits from './Benefits/Benefits';
import OpenPositions from './OpenPositions/OpenPositions';
import LearnMore from './LearnMore/LearnMore';
import './Careers.css';
import CareersHero from './CareersHero/CareersHero';

function Careers() {
  return (
    <div className="careers-page">
      <CareersHero />
      {/* <div className="spacer-m"></div> */}
      <LifeAndPeople />
      <Mission />
      <Benefits />
      <OpenPositions />
      <LearnMore />
      {/* <div className="spacer-l"></div> */}
    </div>
  );
}

export default Careers;